/**
 * Appends the "(2% fee)" parenthetical to an instant payout label, but only
 * once the real fee is known. While the fee is unresolved the parenthetical is
 * withheld rather than filled with a placeholder percentage.
 */
export const selectorInstantPayoutFeeLabel = ({
  text,
  feePercentage
}: {
  text: string;
  feePercentage?: number;
}): string =>
  feePercentage === undefined ? text : `${text} (${feePercentage}% fee)`;
